"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PANEL = void 0;
exports.PANEL = 'py-2 px-4 inline-flex rounded-md min-w-32 w-full h-10';
